import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function getBreadcrumbPath(deptId, tree) {
  let path = [];
  function dfs(node, currentPath) {
    if (node.id === deptId) {
      path = [...currentPath, node];
      return true;
    }
    if (node.enfants) {
      for (let enfant of node.enfants) {
        if (dfs(enfant, [...currentPath, node])) return true;
      }
    }
    return false;
  }
  for (let root of tree) {
    if (dfs(root, [])) break;
  }
  return path;
}

const OrganigrammeSearchBar = ({
  searchTerm,
  setSearchTerm,
  dropdownOpen,
  setDropdownOpen,
  searchResults,
  inputRef,
  selectedDepartement,
  setSelectedDepartement,
  departements,
}) => {
  const { t } = useTranslation();
  return (
  <>
    <div className="relative w-full mb-4">
      <input
        ref={inputRef}
        value={searchTerm}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setDropdownOpen(!!e.target.value);
        }}
        onFocus={() => setDropdownOpen(!!searchTerm)}
        onBlur={() => setTimeout(() => setDropdownOpen(false), 150)}
        className="input-style w-full px-3 py-2 border rounded focus:outline-none focus:ring"
        placeholder={t('org.searchDepartment', 'Search department...')}
        aria-label={t('org.searchDepartment', 'Search department...')}
      />
      {dropdownOpen && searchTerm && (
        <div className="absolute left-0 right-0 mt-1 bg-card border rounded shadow z-50 max-h-64 overflow-y-auto">
          {searchResults.length === 0 ? (
            <div className="text-gray-400 px-4 py-2">{t('common.noResults', 'No results')}</div>
          ) : (
            searchResults.map((result) => (
              <div
                key={result.id}
                tabIndex={0}
                className="result-item px-4 py-2 hover:bg-muted cursor-pointer"
                onMouseDown={() => {
                  setSelectedDepartement(result);
                  setDropdownOpen(false);
                  setTimeout(() => inputRef.current?.focus(), 0);
                }}
              >
                {result.name} <span className="text-xs text-gray-400">{result.path.join(' > ')}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>

    {selectedDepartement && (
      <div className="flex items-center space-x-2 text-sm mb-2">
        {getBreadcrumbPath(selectedDepartement.id, departements).map((dept, idx, arr) => (
          <React.Fragment key={dept.id}>
            <button
              className={`hover:underline focus:outline-none ${
                idx === arr.length - 1 ? 'font-bold text-primary' : 'text-muted-foreground'
              }`}
              onClick={() => setSelectedDepartement(dept)}
              disabled={idx === arr.length - 1}
              type="button"
            >
              {dept.name}
            </button>
            {idx < arr.length - 1 && <ChevronRight className="inline h-4 w-4 mx-1 text-gray-400" />}
          </React.Fragment>
        ))}
      </div>
    )}
  </>
  );
};

export default OrganigrammeSearchBar;
